import { useEffect } from 'react';

import { useNavigate, matchPath, useLocation } from 'react-router-dom';

import { ROUTES } from 'shared/constants';
import { useGetFormattedSettings } from 'shared/hooks/useGetFormattedSettings';
import { useAccessibleAccounts } from 'shared/providers/AccessibleAccounts';

export const useReEnrolmentRedirect = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { paymentRoutesDisabled } = useAccessibleAccounts();
  const { reEnrolment } = useGetFormattedSettings();

  useEffect(() => {
    if (paymentRoutesDisabled && matchPath(ROUTES.HOME, pathname) && reEnrolment?.isEnabled) {
      navigate(`${ROUTES.HOME}${ROUTES.RE_ENROLMENT}`);
    }
  }, [paymentRoutesDisabled, pathname, reEnrolment, navigate]);
};
